module.exports = __webpack_public_path__ + "static/media/icn-moon.c8813a69.svg";